import {WithSummaryModel} from "../../../../../../../common/entity/dto/plain/withSummary.model";
import {TreatmentJourneyStepDefinitionSummaryModel} from "./treatmentJourneyStepDefinitionSummary.model";
import {TreatmentJourneyStepDefinitionTriggerModel} from "./treatmentJourneyStepDefinitionTrigger.model";
import {
    CommunicationContentModelSummaryModel
} from "../../../../../../../communication/content-model/api/entity/communicationContentModelSummary.model";

export class TreatmentJourneyStepDefinitionModel extends WithSummaryModel<TreatmentJourneyStepDefinitionSummaryModel> {
    trigger: TreatmentJourneyStepDefinitionTriggerModel;
    feedbacks: TreatmentJourneyStepDefinitionFeedbackModel[] = [];
    reminders: TreatmentJourneyStepDefinitionReminderModel[] = [];
}

export class TreatmentJourneyStepDefinitionFeedbackModel {
    trigger: TreatmentJourneyStepDefinitionTriggerModel;
    emailSubject: string;
    communicationContentModel: CommunicationContentModelSummaryModel;
}

export class TreatmentJourneyStepDefinitionReminderModel {
    trigger: TreatmentJourneyStepDefinitionTriggerModel;
    emailSubject: string;
    communicationContentModel: CommunicationContentModelSummaryModel;
}